export const CHART_TYPES = {
  LINE: 'line-graph',
  SCATTER: 'scatter-graph',
  BAR: 'bar-chart-graph',
  HORIZONTAL_BAR: 'horizontal-bar-chart-graph',
}
